import { inject, Pipe, PipeTransform } from '@angular/core';
import { AssetFile, AssetFileSize } from '@verify/models';
import { Observable, of } from 'rxjs';
import { StorageService } from '../storage.service';

/**
 * Returns a url for given AssetFile in given format if it exists
 *
 * Usage:
 *  'asset-url' | hasRule
 */
@Pipe({
  name: 'assetUrl',
  standalone: true,
})
export class AssetUrlPipe implements PipeTransform {
  private storageService: StorageService = inject(StorageService);

  transform(
    files: AssetFile[],
    size: AssetFileSize,
    page?: number,
  ): Observable<string> {
    const fileFormat = files?.find(
      (file) => file.size === size && (!file.page || file.page === page),
    );
    if (fileFormat) {
      return this.storageService.getDownloadUrl(fileFormat);
    }
    return of('');
  }
}
